import { useEffect, useState } from "react";

const DISMISS_KEY = "digiponto_pwa_install_dismissed";

export default function PWAInstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) return;
    // iOS standalone já instalado?
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches
      || window.navigator.standalone;
    if (isStandalone) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS detecção: Safari não dispara beforeinstallprompt; mostra tooltip manual
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|mercury/.test(ua);
    if (isIOS && isSafari && !isStandalone) {
      setTimeout(() => setVisible(true), 2500);  // delay pra não assustar
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!prompt) return dismiss();
    prompt.prompt();
    const choice = await prompt.userChoice;
    if (choice.outcome === "accepted") {
      setVisible(false);
      localStorage.setItem(DISMISS_KEY, "installed");
    }
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!visible) return null;

  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);

  return (
    <div className="fixed bottom-16 left-3 right-3 z-30 bg-emerald-600 text-white rounded-xl p-3 shadow-2xl flex items-start gap-2 animate-in slide-in-from-bottom" data-testid="pwa-install-banner">
      <img src="/digiponto-logo.jpeg" alt="" className="h-10 w-10 rounded-md flex-shrink-0" />
      <div className="flex-1 text-xs">
        <div className="font-bold text-sm">Instale o DigiPonto</div>
        {isIOS ? (
          <p className="opacity-90 mt-0.5">Toque em <strong>Compartilhar</strong> no Safari e depois em <strong>"Adicionar à Tela de Início"</strong>.</p>
        ) : (
          <p className="opacity-90 mt-0.5">Tenha o app na tela inicial do celular, sem baixar da loja.</p>
        )}
      </div>
      <div className="flex flex-col gap-1">
        {!isIOS && (
          <button onClick={install} data-testid="btn-install-pwa"
            className="text-[11px] font-bold bg-white text-emerald-700 px-3 py-1 rounded whitespace-nowrap">Instalar</button>
        )}
        <button onClick={dismiss} data-testid="btn-dismiss-install"
          className="text-[10px] opacity-80 underline">Dispensar</button>
      </div>
    </div>
  );
}
